@let titleText = title();
@let descriptionText = description();
<span
  [class]="
    'shadow-light-shade m-4 inline-flex min-w-32 flex-row items-center justify-start gap-4 rounded-md px-4 py-2 shadow-sm' + colorsClasses
  "
>
  <gs-icon [iconName]="iconName()" [iconWeight]="iconWeight()" class="text-3xl"></gs-icon>
  @if (titleText || descriptionText) {
    <span class="flex flex-col items-start justify-center">
      <span class="font-source-sans-3 text-lg font-semibold">{{ titleText }}</span>
      @if (descriptionText) {
        <span class="font-source-sans-3 text-sm">{{ descriptionText }}</span>
      }
    </span>
  }
</span>
